var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.b({'show':_vm.backTop}),style:(_vm.styles),on:{"click":_vm.back}},[_vm._t("default",function(){return [_c('div',{class:_vm.b('icon')},[_c('i',{staticClass:"el-icon-caret-top"})])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }